module.exports = __webpack_public_path__ + "static/media/portfolio1 (36).bb2e8f42.jpeg";